import MicOnOutline from './MicOnOutline'

export default MicOnOutline
// eslint-disable-next-line import/export
export * from './MicOnOutline'
